import { render, staticRenderFns } from "./SectionSeverity.vue?vue&type=template&id=136158bc"
import script from "./SectionSeverity.vue?vue&type=script&lang=ts"
export * from "./SectionSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports